import React from 'react';
import Button from 'olive-react-myoneui/lib/Button';
import { bellIcon } from '../../../constants/icons';
import axios from 'axios';

function BellNotificationItem({ className, notificatonTitle, notificatonDesc, time, buttonTitle ,notificationKey,notificatonUrl,notificatonStatus}) {

  const readNotification = (args) => {
    var formData = new FormData();
    formData.append('notification', args);
    axios({
      method: "post",
      url: "/dashboard/read_notification",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(res => {
      if(res.data.success){
        let host = window.location.hostname
        let url = `https://${host}/${notificatonUrl}`
        window.location.href = url;
      }
     
    })
  }
  console.log(notificatonStatus,"notificatonStatus")
  return (
    <>
    {notificatonTitle && 
      <div className={`${className || ''} notification-item mk-bell-notification-item ${notificatonStatus ? '' : "mk-unread-sign"}`} onClick={() => readNotification(notificationKey)}>
        <div className="mk-bell-notification-bundle d-flex align-items-start gap-2">
          <div className="mk-bell-icon">
            {bellIcon}
            <span className="mk-red-dot"></span>
          </div>
          <div className="mk-bell-notification-text-wrapper">
            <div className="notification-details">
              <div className="notification-heading mk-bell-notification-heading">
                {notificatonTitle && <h1 className="mk-bell-noti-heading" dangerouslySetInnerHTML = {{__html:notificatonTitle}}></h1>}
                {/* {notificatonDesc && <p dangerouslySetInnerHTML={{__html: notificatonDesc}}></p>} */}
                {/* {notificatonDesc && <p>{notificatonDesc}</p>} */}
              </div>
              {time &&
              <div className="notification-time mk-bell-notification-time">
                <p className="mk-bell-noti-time">{time}</p>
              </div>}
            </div>
            {buttonTitle &&
            <div className="notification-action d-flex mt-3">
              <Button variant="outline" className="dark">{buttonTitle}</Button>
            </div>}
          </div>
        </div>
      </div>
      }
    </>
  );
}

export default BellNotificationItem;
